module.exports = __webpack_public_path__ + "media/images/badges/clubpilates/milestone-0-Inactive-ClubPilates-ea7109574317e7d68f19b4ed1bdb7e96.png";